export const FETCH_GOVERNMENT_LIST_REQUEST = "FETCH_GOVERNMENT_LIST_REQUEST";
export const FETCH_GOVERNMENT_LIST_SUCCESS = "FETCH_GOVERNMENT_LIST_SUCCESS";
export const FETCH_GOVERNMENT_LIST_FAILURE = "FETCH_GOVERNMENT_LIST_FAILURE";

export const RESET_GOVERNMENT_LIST_DATA = "RESET_GOVERNMENT_LIST_DATA";
